export class TextareaTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        charsLeft: "{0} tecken kvar"
    };
}
